import React, { ReactNode } from 'react';

type Props = {
  icon: ReactNode;
  label: ReactNode;
  counter: ReactNode;
};

const TabWithIconAndCounter: React.FC<Props> = ({ icon, label, counter }) => (
    <div className="tab-wrapper">
      <div className="icon-wrapper">{icon}</div>
      <div className="label-wrapper">{label}</div>
      <div className="counter-wrapper">{counter}</div>
    </div>
  );

export default TabWithIconAndCounter;
